import { NgModule } from '@angular/core';
import { provideBootstrapEffects } from '@innogy/utils-state';
import { StoreModule } from '@ngrx/store';

import { MemberGetMemberEffects } from './member-get-member-state/member-get-member-state.effects';
import { memberGetMemberReducer } from './member-get-member-state/member-get-member-state.reducer';
import { memberGetMemberSelectorKey } from './member-get-member-state/member-get-member-state.selectors';

@NgModule({
  imports: [
    StoreModule.forFeature(memberGetMemberSelectorKey, memberGetMemberReducer),
  ],
  providers: [provideBootstrapEffects([MemberGetMemberEffects])],
})
export class MemberGetMemberModule {}
